export const DASHBOARD_TEST_IDS = {
  DASHBOARD_STATISTICS_WIDGET: "dashboard_statisticsWidget", 
  DASHBOARD_STATISTICS_SPARKLINE: "dashboard_statisticsSparkline", 
  DASHBOARD_SITE_DROPDOWN: "dashboard_siteDropdown", 
  DASHBOARD_FLOOR_TAB: "dashboard_floorTab", 
  DASHBOARD_SITE_TAB: "dashboard_siteTab", 
  DASHBOARD_BACK_TO_ALL_SITES_LINK: "dashboard_backToAllSitesLink", 
  DASHBOARD_FLOOR_TAB: "dashboard_floorTab", 
  DASHBOARD_ACCORDION_ITEM: "dashboard_accordion-item", 
  DASHBOARD_ACCORDION_ITEM_EXPAND_BUTTON: "dashboard_accordion-item_expandButton", 
  DASHBOARD_ACCORDION_ITEM_CLOSE_BUTTON: "dashboard_accordion-item_closeButton", 
  DASHBOARD_ACCORDION_ITEM_DETAILS_BUTTON: "dashboard_accordion-item_detailsButton",
}; 

export const APPLICATION_IDS_AND_DESC = {
  INTRUSION_DETECTION: {ID : "IntrusionDetection", DESC: "Person detected in the area"},
  SLIP_AND_FALL: {ID : "SlipAndFall", DESC: "Slip and fall detected in the area"},
  PHONE_DETECTION: {ID : "PhoneDetection", DESC: "Phone detected in the area"},
}

export const EVIDENCE_PROCESSING_MESSAGE = "Evidence being processed...";

export const CAMERA_DELETED_MESSAGE = "This camera has been deleted/unpaired.";

export const DASHBOARD_EVENT_CARD_TEXT = {
  LOADING: "Loading events",
  NO_CRITICAL_EVENTS: "No critical events detected",
  CRITICAL_EVENTS_DETECTED: "Critical events detected",
  NEW_EVENT_DETECTED: "New Event Detected",
  NO_MORE_EVENTS: "No more events to fetch",
};

export const EVENT_TYPE = {
  INCIDENT: "Incident",
  SMART_ALERT: "SmartAlert",
}